import * as yup from 'yup';

const STRING_TYPES = ['text', 'email', 'textarea', 'select', 'relation'];

export function buildValidationSchema(fields) {
    const shape = {};

    for (const field of fields) {
        if (!field.showInForm || field.readOnly) continue;

        let validator;

        if (field.type === 'number') {
            validator = yup.number().typeError('Must be a number').nullable();
            if (field.minValue != null) validator = validator.min(field.minValue, `Min ${field.minValue}`);
            if (field.maxValue != null) validator = validator.max(field.maxValue, `Max ${field.maxValue}`);
        } else if (field.type === 'boolean') {
            validator = yup.boolean();
        } else if (field.type === 'array') {
            validator = yup.array();
            if (field.required) validator = validator.min(1, 'Required');
        } else if (field.type === 'date') {
            validator = yup.date().nullable().typeError('Invalid date');
        } else if (STRING_TYPES.includes(field.type)) {
            validator = yup.string();
            if (field.minLength) validator = validator.min(field.minLength, `Min ${field.minLength} characters`);
            if (field.maxLength) validator = validator.max(field.maxLength, `Max ${field.maxLength} characters`);
            if (field.type === 'email') validator = validator.email('Invalid email');
        } else {
            validator = yup.mixed();
        }

        if (field.required && field.type !== 'array') {
            validator = validator.required('Required');
        }

        shape[field.name] = validator;
    }

    return yup.object().shape(shape);
}
